import React from "react";
import { StatusChip } from "@/components/kcc/Kpi";

export function DataTable({ columns, rows, testid = "data-table", empty = "No data" }) {
    if (!rows?.length) return <div className="kcc-text-dim text-sm italic p-6 text-center">{empty}</div>;
    return (
        <div className="overflow-x-auto" data-testid={testid}>
            <table className="w-full text-sm">
                <thead>
                    <tr className="text-left">
                        {columns.map((c) => (
                            <th key={c.key} className="kcc-label border-b border-white/5 py-3 px-3 font-semibold">{c.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((r, i) => (
                        <tr key={r.id || i} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors">
                            {columns.map((c) => (
                                <td key={c.key} className="py-3 px-3 align-top" data-testid={`cell-${c.key}-${i}`}>
                                    {c.render ? c.render(r) : (r[c.key] ?? "—")}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export { StatusChip };

export function statusToChip(v) {
    const s = (v || "").toString().toLowerCase();
    if (["closed", "completed", "verified", "resolved", "ok", "normal", "green", "active", "delivered", "approved", "published"].some(k => s.includes(k))) return "normal";
    if (["warning", "amber", "watch", "reduced_rate", "under review", "investigating", "reorder", "medium"].some(k => s.includes(k))) return "warning";
    if (["critical", "red", "alert", "exceedance", "escalated", "lost time", "high potential", "high", "underperforming", "down"].some(k => s.includes(k))) return "critical";
    if (["info", "draft", "planned", "scheduled", "in progress", "awaiting", "low"].some(k => s.includes(k))) return "info";
    return "normal";
}
